import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // For desktop Company dropdown
  const [isMobileCompanyOpen, setIsMobileCompanyOpen] = useState(false); // For mobile Company dropdown

  // Handle scrolling effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking a link or outside
  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsMobileCompanyOpen(false);
  };

  // Toggle mobile company dropdown
  const toggleMobileCompany = (e) => {
    e.preventDefault();
    setIsMobileCompanyOpen(!isMobileCompanyOpen);
  };

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="logo-container" onClick={closeMenu}>
          <img src="/NTlogo.png" alt="NoetherTech Logo" className="logo" />
          <span className="company-name">NoetherTech</span>
        </Link>

        {/* Hamburger Menu Button - Only visible on mobile */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Desktop Navigation - Hidden on mobile */}
        <nav className="desktop-nav">
          <ul>
            {/* Removed Home link for desktop */}
            <li><Link to="/technology">Technology</Link></li>
            <li><Link to="/science">Science</Link></li>
            <li 
              className="dropdown"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <span className="dropdown-trigger">About Us</span>
              <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                <Link to="/team">Our Team</Link>
                <Link to="/history">History</Link>
              </div>
            </li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Mobile Navigation - Only appears when hamburger is clicked */}
        <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
          <nav>
            <ul>
              <li><Link to="/" onClick={closeMenu}>Home</Link></li>
              <li><Link to="/technology" onClick={closeMenu}>Technology</Link></li>
              <li><Link to="/science" onClick={closeMenu}>Science</Link></li>
              <li className="mobile-dropdown">
                <button type="button" onClick={toggleMobileCompany} className="mobile-dropdown-trigger">
                  About Us <span className="arrow-icon">{isMobileCompanyOpen ? '↓' : '→'}</span>
                </button>
                <div className={`mobile-dropdown-content ${isMobileCompanyOpen ? 'open' : ''}`}>
                  <Link to="/team" onClick={closeMenu} className="mobile-dropdown-item">Our Team</Link>
                  <Link to="/history" onClick={closeMenu} className="mobile-dropdown-item">History</Link>
                </div>
              </li>
              <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
            </ul>
          </nav>
        </div>

        {/* Overlay for closing menu when clicking outside */}
        {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      </div>
    </header>
  );
}

export default Navbar;
